<script>
import resources from './resources'

export default {
  name: 'crud-index',

  mixins: [resources]
}
</script>

<template lang="pug">
  page(:title="title")
    slot
</template>



// WEBPACK FOOTER //
// src/crud/index/index.vue